import { render } from "./wx-web-login.vue?vue&type=template&id=1f46cd6a&scoped=true&ts=true"
import script from "./wx-web-login.vue?vue&type=script&lang=ts"
export * from "./wx-web-login.vue?vue&type=script&lang=ts"

import "./wx-web-login.vue?vue&type=style&index=0&id=1f46cd6a&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f46cd6a"]])